import React, { useState, useEffect } from "react";
import styles from "../../Styles/creator/styles.module.css";
import avatar from "../../images/avatar.png";
import ReactStars from "react-stars";
import { getUserByID } from "../../helper/reveiwApiCalls/reveiw";

const Reveiw = ({ rev }) => {
  const [mainuser, setUser] = useState("");
  const [obj, setObj] = useState({});
  function fetchUser() {
    getUserByID(rev.user).then((data) => {
      if (data.status === "fail") {
        console.log(data.message);
      } else {
        setUser(data.data.name);
        setObj(data.data);
      }
    });
  }

  useEffect(() => {
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const reviewDescription = rev ? rev.comment : "error in getting review";

  const rating = rev ? rev.rating : "error in getting rating";

  const profile = obj ? obj.profileimage : "error in";

  return (
    <div className={styles.rev}>
      <div className={styles.pic}>
        {profile === undefined && <img alt="%" src={avatar} />}
        {profile !== undefined && <img alt="%" src={profile} />}
      </div>
      <div className={styles.real}>
        <div className={styles.real1}>
          <span>{mainuser}</span>
        </div>
        <div className={styles.real2}>
          <ReactStars
            count={5}
            size={24}
            value={rating}
            color2={"#ffd700"}
            edit={false}
          />
        </div>
        <div className={styles.real3}>
          <span>{reviewDescription}</span>
        </div>
      </div>
    </div>
  );
};
export default Reveiw;
